module.exports = __webpack_public_path__ + "static/media/Montserrat-Light.d4a8834f.otf";